import useLocationStateStack from "../../app/useLocationStateStack";

export default function useProfileOverlayHistory({
  mobileMenuOpen,
  setMobileMenuOpen,
  showFavorites,
  handleCloseFavorites,
  showTrips,
  handleCloseTrips,
  showCatches,
  handleCloseCatches,
  fullscreenMedia,
  handleCloseFullscreenMedia,
  showCoverEdit,
  handleCloseCoverEdit,
  showAvatarPositionModal,
  handleAvatarPositionCancel,
  showCoverPositionModal,
  handleCoverPositionCancel,
  editingPost,
  handleCloseEditPost,
}) {
  return useLocationStateStack("profileOverlayStack", [
    {
      id: "profile-mobile-menu",
      isOpen: mobileMenuOpen,
      close: () => setMobileMenuOpen(false),
    },
    {
      id: "profile-favorites",
      isOpen: showFavorites,
      close: handleCloseFavorites,
    },
    {
      id: "profile-trips",
      isOpen: showTrips,
      close: handleCloseTrips,
    },
    {
      id: "profile-catches",
      isOpen: showCatches,
      close: handleCloseCatches,
    },
    {
      id: "profile-fullscreen-media",
      isOpen: Boolean(fullscreenMedia),
      close: handleCloseFullscreenMedia,
    },
    {
      id: "profile-cover-edit",
      isOpen: showCoverEdit,
      close: handleCloseCoverEdit,
    },
    {
      id: "profile-avatar-position",
      isOpen: showAvatarPositionModal,
      close: handleAvatarPositionCancel,
    },
    {
      id: "profile-cover-position",
      isOpen: showCoverPositionModal,
      close: handleCoverPositionCancel,
    },
    {
      id: "profile-edit-post",
      isOpen: Boolean(editingPost),
      close: handleCloseEditPost,
    },
  ]);
}
